import React from 'react';
import { PropTypes } from 'prop-types';

import Link from 'components/styled/link';
import { Checkbox } from '@ontruck/orc';

import { Trans } from 'react-i18next';

const GDPROptions = ({
  className,
  t,
  handleAcceptedTerms,
  acceptedTerms,
  handleCommercialCommunications,
  commercialCommunications,
  privacyUrl,
  conditionsUrl,
}) => (
  <div className={className}>
    <div className="option">
      <Checkbox
        id="acceptedTerms"
        name="acceptedTerms"
        size="L"
        onChange={handleAcceptedTerms}
        checked={acceptedTerms}
      />
      <span className="label">
        <Trans
          t={t}
          i18nKey="gdpr_checkbox_label_terms_policy"
          components={[
            <Link
              size="L"
              href={privacyUrl}
              target="_blank"
              text={t('gdpr_privacy_policy')}
              className="summary-legal-link"
            />,
            <Link
              size="L"
              href={conditionsUrl}
              target="_blank"
              text={t('gdpr_terms_and_conditions')}
              className="summary-legal-link"
            />,
          ]}
        />
      </span>
    </div>
    <div className="option">
      <Checkbox
        id="commercialCommunications"
        name="commercialCommunications"
        size="L"
        onChange={handleCommercialCommunications}
        checked={commercialCommunications}
      />
      <span className="label">{t('gdpr_commercial_communication')}</span>
    </div>
  </div>
);

GDPROptions.propTypes = {
  className: PropTypes.string,
  conditionsUrl: PropTypes.string.isRequired,
  privacyUrl: PropTypes.string.isRequired,
  t: PropTypes.func,
  handleAcceptedTerms: () => ({}),
  acceptedTerms: false,
  handleCommercialCommunications: () => ({}),
  commercialCommunications: false,
};

GDPROptions.defaultProps = {
  className: '',
  t: () => {},
  handleAcceptedTerms: () => ({}),
  acceptedTerms: false,
  handleCommercialCommunications: () => ({}),
  commercialCommunications: false,
};

export default GDPROptions;
